// Naslovna sezonskih karata: tabovi Loyalty/Starter (?tip=starter ili #starter) i odbrojavanje do kraja intervala.
(function () {
  function init(root) {
    if (root.dataset.agInit) return;
    root.dataset.agInit = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ag-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ag-panel]'));
    var notes = Array.prototype.slice.call(root.querySelectorAll('[data-ag-note]'));

    function select(id, focus) {
      tabs.forEach(function (t) {
        var on = t.dataset.agTab === id;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      panels.forEach(function (p) { p.hidden = p.dataset.agPanel !== id; });
      notes.forEach(function (n) { n.hidden = n.dataset.agNote !== id; });
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t.dataset.agTab); });
      t.addEventListener('keydown', function (e) {
        var j = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : -1;
        if (j < 0) return;
        e.preventDefault();
        select(tabs[(j + tabs.length) % tabs.length].dataset.agTab, true);
      });
    });

    var want = /[?&]tip=(loyalty|starter)/.exec(location.search) || /#(loyalty|starter)$/.exec(location.hash);
    select(want ? want[1] : 'loyalty');

    var count = root.querySelector('[data-ag-countdown]');
    if (count) {
      var end = Number(count.dataset.end) * 1000;
      var left = Math.ceil((end - Date.now()) / 86400000);
      if (left > 1) count.textContent = 'još ' + left + ' dana do ' + count.dataset.date;
      else if (left === 1) count.textContent = 'još 1 dan do ' + count.dataset.date;
      else if (left === 0) count.textContent = 'posljednji dan: ' + count.dataset.date;
    }
  }
  function boot() { document.querySelectorAll('[data-ag-home]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
